import { gql } from '@apollo/client'

const GET_ACADEMY_RESOURCES = gql`
  query resources(
    $featured: Boolean
    $limit: Int
    $popular: Boolean
    $query: String
    $sort: ResourceSortOptions
    $resourceType: [ResourceType!]
    $bookmarked: Boolean
    $status: [ResourceStatus!]
    $ids: [String!]
    $tags: [String!]
    $idsToExclude: [String!]
    $anonymousId: String
    $createdAtGte: DateTime
    $updatedAtGte: DateTime
    $topics: [String!]
    $levels: [ResourceLevel!]
  ) {
    resources(
      featured: $featured
      limit: $limit
      popular: $popular
      query: $query
      sort: $sort
      resourceType: $resourceType
      bookmarked: $bookmarked
      status: $status
      ids: $ids
      tags: $tags
      idsToExclude: $idsToExclude
      anonymousId: $anonymousId
      createdAtGte: $createdAtGte
      updatedAtGte: $updatedAtGte
      topics: $topics
      levels: $levels
    ) {
      nodes {
        bookmarked
        description
        featured
        gatedByPlan
        id
        nonprofitTopic
        popular
        thumbnailUrl
        tags
        topics
        levels
        title
        type
        createdAt
        updatedAt
        ... on Course {
          completionTime
          courseId
          status
        }
        ... on PartialLearningTrackResource {
          status
        }
      }
      totalCount
    }
  }
`
export default GET_ACADEMY_RESOURCES
